import { render, staticRenderFns } from "./EnablePropertiesField.vue?vue&type=template&id=3391e041&scoped=true&"
import script from "./EnablePropertiesField.vue?vue&type=script&lang=js&"
export * from "./EnablePropertiesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3391e041",
  null
  
)

export default component.exports